import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Row, Col, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome } from '@fortawesome/free-solid-svg-icons';

//@ts-ignore
import ReactFlagsSelect from 'react-flags-select';

import './Header.scss';

import logo from '../../assets/images/logo-BG.svg';

/**
 * Site's header
 * 
 * @component - Header
 * @parentComponent - App
 */

const Header = () => {

  const { t, i18n } = useTranslation();

  const defaultLang = 'BG';
  const [selectedLanguage, setSelectedLanguage] = useState('BG');
  const homeLink = "https://www.bgtoll.bg/";

  const changeLanguage = (countryCode:string) => {
    let langCode;
    switch (countryCode) {
      case "GB":
        langCode = "EN";
        break;
      case "RS":
        langCode = "SR";
        break;
      default:
        langCode = countryCode;
    }

    setSelectedLanguage(countryCode);
    i18n.changeLanguage(langCode);
    localStorage.setItem('selectedLang', JSON.stringify(countryCode));
  };

  useEffect(() => { 
    const localSelectedLang = localStorage.getItem('selectedLang');
    
    //Add selected language to local storage if not
    if (!localSelectedLang) localStorage.setItem('selectedLang', JSON.stringify(defaultLang));
    //Change to user prev selection
    if(localSelectedLang && localSelectedLang !== defaultLang) {
      changeLanguage(JSON.parse(localSelectedLang));
    }
  }, []);

  return(
      <div className="Header">
        <Container>
          <Row>
              <Col className="logo-container" md={6} sm={4}>
                <img src={logo} className="site-logo" alt="BG Toll" />
              </Col>
              <Col className="nav-container"  md={6} sm={8}>
                <a href={homeLink} className="home-link">
                  <FontAwesomeIcon icon={faHome} />
                  <span className="home-link__title">{t('Header.homeLink')}</span>
                </a>
                <ReactFlagsSelect
                  selected={selectedLanguage}
                  countries={["BG", "GB", "DE","RS","TR","RU","RO","GR" ]} 
                  customLabels={{"GB": "english", "BG": "български", "DE": "deutsch","RS": "српски", "TR": "türkçe", "RU": "русский", "RO":"română","GR":"ελληνικά" }} 
                  onSelect={changeLanguage}
                />
              </Col>
          </Row>
        </Container>
    </div>
)
}
export default Header;
